import "./AboutContentStyles.css";
import React1 from "../assets/react1.jpg";
import React2 from "../assets/react2.webp";

import React from 'react'
import { Link } from "react-router-dom";

const AboutContent = () => {
    return (
        <div className="about">
            <div className="left">
                <h1>Who Am I?</h1>
                <p>Im a MERN fullstack developer. I have certified with Fullstack Developer from GUVI. I completed B.E(ECE) in Asian college of Engineering and Technology at Coimbatore.</p>
                <Link to="/contact"><button className="btn">Contact</button></Link>
            </div>

            <div className="right">
                <div className="img-container">
                    <div className="img-stack top">
                        <img src={React1} className="img" alt="true" />
                    </div>
                    <div className="img-stack bottom">
                        <img src={React2} className="img" alt="true" />
                    </div>

                </div>
            </div>

        </div>
    )
}

export default AboutContent
